import './category_type_lists_component.scss'
